// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/account/CreateDSAWorkflowConversionConfirmationModal.scss
// module id = 1270
// module chunks = 0